{
  "fr": {
    "chart": {
      "type": {
        "bar": "Graphique à barres",
        "bubble": "Graphique à bulles",
        "doughnut": "Graphique en anneau",
        "horizontalBar": "Graphique à barres horizontales",
        "line": "Graphique linéaire",
        "multiAxis": "Graphique multi-axes",
        "pie": "Graphique circulaire",
        "polarArea": "Graphique en aires polaires",
        "radar": "Graphique radar",
        "stackedBar": "Graphique à barres empilées"
      }
    }
  }
}